<template>
  <div v-show="bundle_info.bundle_id">
    <div class="ui px-gen form">
      <div class="fields">
        <div class="five wide field">
          <label>{{ $t("start date") }}</label>
          <div class="ui calendar" ref="rangestart">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text" />
            </div>
          </div>
        </div>
        <div class="five wide field">
          <label>{{ $t("end date") }}</label>
          <div class="ui calendar" ref="rangeend">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text" />
            </div>
          </div>
        </div>
        <div class="five wide field">
          <label>{{ $t("apply") }}</label>
          <div class="ui two buttons">
            <div class="ui icon labeled blue button" @click="apply">
              <i class="check icon"></i> {{ $t("apply") }}
            </div>
            <div class="ui icon labeled button" @click="download">
              <i class="download icon"></i> {{ $t("download") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui grid px-gen m-0 charts-nvidia py-1">
      <weekly-sends ref="weekly_sends" />
      <platform-totals ref="platform_totals" />
      <gpu-totals ref="gpu_totals" :gpus="gpus" />
      <country-sends ref="country_sends" :stores="stores" />
      <partner-total ref="partner_total" :stores="stores" />
      <!-- <pre>{{ bundle_info }}</pre> -->
    </div>
  </div>
</template>

<script>
// import Chart from "chart.js";
import { local_api, error_toast } from "@/utils";
import WeeklySends from "./WeeklySends.vue";
import PlatformTotals from "./PlatformTotals.vue";
import GpuTotals from "./GpuTotals.vue";
import CountrySends from "./CountrySends.vue";
import PartnerTotal from "./PartnerTotal.vue";
import moment from "moment";

export default {
  name: "",
  data() {
    return {
      bundle_info: {},
      gpus: [],
      stores: [],
      start_date: "",
      end_date: "",
    };
  },
  components: {
    WeeklySends,
    PlatformTotals,
    GpuTotals,
    CountrySends,
    PartnerTotal,
  },
  methods: {
    setBundle(bundle) {
      this.bundle_info = bundle;

      let requests = bundle.nvb_code_requests || [];

      this.$refs.weekly_sends.setRequests(requests);
      this.$refs.platform_totals.setRequests(requests);
      this.$refs.gpu_totals.setRequests(requests);
      this.$refs.country_sends.setRequests(requests);
      this.$refs.partner_total.setRequests(requests);
    },
    setStores(stores) {
      this.stores = stores;

      // this.$refs.country_sends.setStores(stores);
    },
    apply() {
      let vm = this;
      let requests = vm.bundle_info.nvb_code_requests || [];
      let reqs = requests.filter((rq) => {
        const compareDate = moment(rq.create_date);
        const startDate = moment(vm.start_date);
        const endDate = moment(vm.end_date);
        const isBetween = compareDate.isBetween(
          startDate,
          endDate,
          undefined,
          "[]",
        );
        return isBetween;
      });

      this.$refs.weekly_sends.setRequests(reqs);
      this.$refs.platform_totals.setRequests(reqs);
      this.$refs.gpu_totals.setRequests(reqs);
      this.$refs.country_sends.setRequests(reqs);
      this.$refs.partner_total.setRequests(reqs);
    },
    download() {},
  },
  mounted() {
    let vm = this;
    local_api(this, "post", "/nvidia_bundle/graphic_card/do-get-list", {})
      .then((list) => {
        vm.gpus = list;
      })
      .catch((err) => {
        error_toast(err);
      });

    window.jQuery(vm.$refs.rangestart).calendar({
      type: "date",
      endCalendar: window.jQuery(vm.$refs.rangeend),
      onChange(value) {
        vm.start_date = value;
      },
    });
    window.jQuery(vm.$refs.rangeend).calendar({
      type: "date",
      startCalendar: window.jQuery(vm.$refs.rangestart),
      onChange(value) {
        vm.end_date = value;
      },
    });
  },
};
</script>

<style scoped>
/* @import url("https://nworkforce.com/librerias/css/fonts/fonts.css"); */

/*  SPACING   */
.py-05 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.m-0 {
  margin: 0 !important;
}
.my-0 {
  margin-bottom: 0 !important;
  margin-top: 0 !important;
}
.px-gen {
  padding-right: 2rem !important;
  padding-left: 2rem !important;
}
.pl-0 {
  padding-left: 0 !important;
}

/*  FONTS   */
.has-text-centered {
  text-align: center !important;
}
.has-text-left {
  text-align: left !important;
}
.is-uppercase {
  text-transform: uppercase !important;
}
.fdinpro {
  font-family: "DINPro" !important;
}

/*  GRAFICAS    */
.charts-nvidia div .is-uppercase {
  background-color: #666666 !important;
  color: white !important;
  padding: 0.5rem 1rem 0.5rem;
}

/* INFORMACION BUNDLE*/
.info-bundle .ten table tbody tr td {
  text-align: center;
  font-size: 90% !important;
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
}
.info-bundle .ten table tbody tr td button {
  font-size: 90% !important;
}
.info-bundle .ten table tbody tr .six.wide button {
  border-radius: 2rem;
}
.info-bundle .six table tbody tr td {
  text-align: left;
  font-size: 90% !important;
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
}
.info-bundle .six table tbody tr td button {
  font-size: 90% !important;
}
.info-bundle .six table tbody tr .six.wide button {
  border-radius: 2rem;
}
.ibundle-button-green {
  background-color: #666666 !important;
  color: white !important; /*width: 100%;*/
  font-family: "DINPro" !important;
  font-weight: 500;
}
.ibundle-button-green.active {
  background-color: #365a0c !important;
}
.ibundle-button-green:hover {
  background-color: #365a0c !important;
}

/*  MODAL FORMS   */
.default-header-green {
  border-bottom: 2pt solid #365a0c !important;
  font-weight: 300;
  font-size: 1.5rem !important;
}
.modal-button-green {
  background-color: #365a0c !important;
  color: white !important; /*width: 100%;*/
  font-family: "DINPro" !important;
  font-weight: 500;
}
.modal-button-green:hover {
  background-color: rgb(118, 185, 0) !important;
}

/*  HISTORIAL DE ENVIOS */
.sb-button {
  display: flex !important;
  flex-direction: row;
  text-align: left !important;
  background-color: transparent !important;
  color: #606060 !important;
}
.sb-button:hover {
  color: white !important;
  background-color: #365a0c !important;
}
.sb-button.active {
  color: white !important;
  background-color: #365a0c !important;
}
.pre-sb-button {
  flex: 20%;
}
.name-sb-button {
  flex: 80%;
}
</style>
